export default {
	title: '物联网卡管理',
	actions: {
		add: '新增',
                import: '导入',
                exportTemplate: '模板导出',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除',
		expiringSoon: '过期预警'
	},
	messages: {
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '操作成功',
		selectDeleteWarning: '请选择要删除的记录',
		operateSuccess: '操作成功',
                requiredFieldCannotBeEmpty: '必填项不能为空',
                importSuccess: '导入成功',
                importFailed: '导入失败：',
                fileTooLarge: '文件大小不能超过 100MB'
	},
	form: {
		projNo: '项目编号',
		number: '物联网卡编号',
		iccid: 'IC 卡识别码',
		placeholder: {
			projNo: '请输入项目编号',
			number: '请输入物联网卡编号',
			iccid: '请输入 IC 卡识别码',
			buyDateStart: '购买开始时间',
			buyDateEnd: '购买结束时间',
			expireDateStart: '过期开始时间',
			expireDateEnd: '过期结束时间'
		}
	},
	table: {
		number: '物联网卡编号',
		iccid: 'IC 卡识别码',
		projNo: '项目编号',
		bindType: '网关/传感器',
		terminalId: '终端 id',
		sensorId: '关联传感器',
		buyDate: '购买时间',
		expireDate: '过期时间',
		status: '物联卡状态',
		active: '激活状态',
		trafficMonthly: '每月流量',
		trafficUsed: '已用流量 (M)',
		serviceCycle: '服务周期',
		mobileCarrier: '运营商'
	},
	dialog: {
		add: '新增',
		edit: '修改',
		cancel: '取消',
		confirm: '确定'
	},
	widgetForm: {
		number: '物联网卡编号',
		iccid: 'IC 卡识别码',
		projNo: '所属项目',
		bindType: '绑定类型',
		terminalId: '终端/网关 id',
		sensorId: '关联传感器 id',
		buyDate: '购买时间',
		expireDate: '过期时间',
		allotDate: '出库时间',
		trafficMonthly: '每月流量',
		trafficUsed: '已用流量',
		mobileCarrier: '运营商',
		serviceCycle: '服务周期',
		gridLayout: '格栅布局',
		requiredFieldCannotBeEmpty: '必填项不能为空',
		placeholder: {
			number: '请输入物联网卡编号',
			iccid: '请输入 IC 卡识别码',
			projNo: '请输入项目编号',
			bindType: '请选择绑定类型',
			terminalId: '请输入终端/网关 id',
			sensorId: '请输入关联传感器 id',
			buyDate: '请选择购买时间',
			expireDate: '请选择过期时间',
			allotDate: '请选择出库时间',
			trafficMonthly: '请输入每月流量',
			trafficUsed: '请输入已用流量',
			mobileCarrier: '请选择运营商',
			serviceCycle: '请输入服务周期'
		},
		options: {
			bindType: {
				gateway: '网关',
				sensor: '传感器'
			},
			mobileCarrier: {
				telecom: '电信',
				mobile: '移动',
				unicom: '联通'
			}
		}
	}
}
